export const ALGOLIA_APP_ID = "JE3MLT8BFM"
export const ALGOLIA_SEARCH_KEY = "bf39effacce45293384517b97c2f2b5c"

export const colorModes = ["light", "dark"]
